var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D73E35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1875 55.5625C51.875 55.875 51.5 56 51.125 56C50.6875 56 50.3125 55.875 50.0625 55.5625L44 49.5L37.9375 55.5625C37.625 55.875 37.25 56 36.875 56C36.4375 56 36.0625 55.875 35.8125 55.5625L32.4375 52.1875C32.125 51.9375 32 51.5625 32 51.125C32 50.75 32.125 50.375 32.4375 50.0625L38.5 44L32.4375 37.9375C32.125 37.6875 32 37.3125 32 36.875C32 36.5 32.125 36.125 32.4375 35.8125L35.8125 32.4375C36.0625 32.1875 36.4375 32 36.875 32C37.25 32 37.625 32.1875 37.9375 32.4375L44 38.5L50.0625 32.4375C50.3125 32.1875 50.6875 32 51.125 32C51.5 32 51.875 32.1875 52.1875 32.4375L55.5625 35.8125C55.8125 36.125 56 36.5 56 36.875C56 37.3125 55.8125 37.6875 55.5625 37.9375L49.5 44L55.5625 50.0625C55.8125 50.375 56 50.75 56 51.125C56 51.5625 55.8125 51.9375 55.5625 52.1875L52.1875 55.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.c7447f2fe89ca06915ff6a13087c8ec0.svg";
export { ForwardRef as ReactComponent };